/**
 * Export `newsExhibitionsCategories`.
 */

export const newsExhibitionsCategories = {
  exhibitions: 'exhibitions',
  news: 'news'
} as const;

/**
 * Export `orderedNewsExhibitionsCategories`.
 */

export const orderedNewsExhibitionsCategories = [
  newsExhibitionsCategories.news,
  newsExhibitionsCategories.exhibitions
];
